import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "dashboard" }

import { onMounted } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useSSE, useAuth, useRoot } from '@/stores/store';
    import { Wrapper, Error, Columns } from '@/components';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Dashboard',
  setup(__props) {

    const sseState = useSSE();
    const authState = useAuth();
    const rootState = useRoot();

    const { authenticated } = storeToRefs(authState);
    const { getErrorStatus, getSelectedSite } = storeToRefs(rootState);
    const { listen } = sseState;

    onMounted(() => listen());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Wrapper), null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(getErrorStatus) && _unref(authenticated))
          ? (_openBlock(), _createBlock(_unref(Error), { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_unref(Columns), { "selected-site-i-d": _unref(getSelectedSite) }, null, 8, ["selected-site-i-d"])
      ])
    ]),
    _: 1
  }))
}
}

})